export default __webpack_public_path__ + "static/media/dragger.28ad9afb.svg";